// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--nJN4J","price-diff":"da51a739f7--price-diff--ocxIY","content":"da51a739f7--content--EORQ7"};